import { createFileRoute } from "@tanstack/react-router";
import { EntityFormPage } from "@/components/entity-page/EntityFormPage";
import CreateIntegrationForm from "@/components/CreateIntegrationForm";

export const Route = createFileRoute("/dashboard/clients/$id/integrations/new")({
  component: CreateIntegrationPage,
});

function CreateIntegrationPage() {
  const { id } = Route.useParams();
  return <CreateIntegrationPageComponent businessId={id} />;
}

// Exported for testing
export function CreateIntegrationPageComponent({
  businessId,
}: {
  businessId: string;
}) {
  return (
    <EntityFormPage
      title="Create Integration"
      description="Add a new integration to this client."
      backHref={`/dashboard/clients/${businessId}`}
    >
      <CreateIntegrationForm businessId={businessId} />
    </EntityFormPage>
  );
}
